import { makeVar, ReactiveVar } from '@apollo/client'

import { ITag } from 'shared/interfaces'
import { Feed } from 'shared/__gql-types'

export const FeedStore = {
  globalProjectFeed: {
    read: () => globalProjectFeedVar()
  },
  globalProjectFeedFilter: {
    read: () => globalProjectFeedFilterVar()
  }
}

export const globalProjectFeedVar: ReactiveVar<Feed[]> = makeVar<Feed[]>([])
export const globalProjectFeedFilterVar: ReactiveVar<ITag[]> = makeVar<ITag[]>([])
